import { type z } from "zod";

import { packagingComponentBaseSchema } from "./packaging-component-base";

export const packagingComponentLabelSchema = packagingComponentBaseSchema.extend({});

export type PackagingComponentLabel = z.infer<typeof packagingComponentLabelSchema>;
